import React, { Component } from 'react';
import Slider from 'react-slick';
import { Waypoint } from 'react-waypoint';
import { Col, Row, Container} from 'reactstrap';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const items = [
	{
		src: `${config.cdnUrl}/static/images/home/sustained-impact-desktop-card.jpg`,
		name: 'Sustained change',
		bgsrc: `${config.cdnUrl}/static/images/home/sustained-impact-card.svg`,
		text: ' Help build a better future for the poor',
	},
	{
		src: `${config.cdnUrl}/static/images/home/deeper-engagement-desktop-card.jpg`,
		name: 'Engage deeply',
		bgsrc: `${config.cdnUrl}/static/images/home/deeper-engagement-card.svg`,
		text: 'Stay connected with the lives you impact',
	},
  {
    src: `${config.cdnUrl}/static/images/home/big-impact-desktop-card.jpg`,
    name: 'Big impact',
		bgsrc: `${config.cdnUrl}/static/images/home/big-impact-card.svg`,
		text: 'Small monthly donations lead to large scale impact',
    },
];
const settingsSlider = {
	arrows: false,
	dots: false,
	infinite: false,
	speed: 100,
	slidesToShow: 1.1,
	slidesToScroll: 1,
};
export default class ImpactCard extends Component {
	constructor(props) {
		super(props);
		this.state = { visible: false };
	}

	_handleWaypointEnter = () => {
		this.setState({
			visible: true
		});
	};

	impactCardPanel = items => items.map((item, idx) => {
		const isVisible = this.state.visible;

		return (
		<Col key={idx} xs="12" sm="12" md="4" lg="4">
			<div className="card impact-card">
				{isVisible? <img className="card-img-top" src={item.src} alt="Card image cap"/> : null}
				<div className="centered justify-content-center align-self-center w-100 text-center"><h2 style={{ color: 'white'}}>{item.name}</h2></div>
				{isVisible? <div className=""><img className="centered-image-on-background image-bg-impact" src={item.bgsrc} alt="Card image cap"/></div> : null}
				<div className="centered-text-on-background text-center ">
					<p className="justify-content-center align-self-center ">{item.text} </p>
				</div>
			</div>
		</Col>
		);
	});

render() {
	return (
		<Container>
			<Waypoint onEnter={this._handleWaypointEnter} bottomOffset={-300} />
			<div>
				<div>
					<Row style={{ paddingLeft: '15px' }}>
						<h2 className="mr-auto" style={{ marginBottom: '2rem' }}>
							<span style={{ color: this.props.theme.primaryColor }}>
								Monthly giving
							</span>{' '}
							helps you commit to long term change
						</h2>
					</Row>
				</div>
				<Row className="impact-card-on-desktop">
					{this.impactCardPanel(items)}
				</Row>
				<div className="impact-card-on-mobile">
					<Slider {...settingsSlider} className="">
						{this.impactCardPanel(items)}
					</Slider>
				</div>

				<style jsx global>
					{`
						.impact-card {
							border-radius: 10px;
						}
						@media (max-width: 768px) {
							.impact-card-on-mobile {
								display: block;
							}

							.impact-card-on-desktop {
								display: none;
							}
							.slick-track {
								margin-left: 0 !important;
							}
						}

						@media (min-width: 768px) {
							.impact-card-on-mobile {
								display: none;
							}

							.impact-card-on-desktop {
								display: flex;
							}
						}

						.image-bg-impact {
							height: 65px;
							opacity: 0.8;
						}
						.centered-text-on-background {
							position: absolute;
							top: 65%;
							font-size: 16px;
							bottom: 0px;
							left: 37%;
							transform: translate(-50%, -50%);
							padding: 0px 3rem 1.5rem 3rem;
							color: white;
						}
						.centered-image-on-background {
							position: absolute;
							top: 24%;
							left: 50%;
							transform: translate(-50%, -50%);
							color: white;
						}
						.centered {
							position: absolute;
							top: 50%;
							left: 37%;
							transform: translate(-50%, -50%);
							color: white;
						}

						.card-img-top {
							border-radius: 6px;
						}
					`}
				</style>
			</div>
		</Container>
	);
}
}
